"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: LayersIcon
exports.LayersIcon = iconFactory_1.iconFactory({
    componentName: 'LayersIcon',
    viewBox: '0 0 32 32',
    title: 'LayersIcon',
    g: "<g>\n<path d=\"M6.848 23.936v-11.008h-3.744v15.872h15.872v-3.712h-10.976c-0.64 0-1.152-0.512-1.152-1.152z\"/>\n<path d=\"M13.056 3.2h15.84v15.808h-15.84v-15.808z\"/>\n<path d=\"M19.136 20.192h-6.208c-0.64 0-1.152-0.512-1.152-1.152v-11.008h-3.776v15.872h15.904v-3.712h-4.768z\"/>\n</g>",
    gThemed: { "ergo-one": { "viewBox": "0 0 32 32", "g": "<g><path d=\"M6.848 23.936v-11.008h-3.744v15.872h15.872v-3.712h-10.976c-0.64 0-1.152-0.512-1.152-1.152z\"/><path d=\"M13.056 3.2h15.84v15.808h-15.84v-15.808z\"/><path d=\"M19.136 20.192h-6.208c-0.64 0-1.152-0.512-1.152-1.152v-11.008h-3.776v15.872h15.904v-3.712h-4.768z\"/></g>" } }
});
exports.default = exports.LayersIcon;
//# sourceMappingURL=LayersIcon.js.map